module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_2015.a78397a2.jpg";